import { useQuery } from '@tanstack/react-query';

import { paymentService } from '../services/payment.service';

export const usePayment = (id: string) => {
  return useQuery({
    queryKey: ['payment', id],
    queryFn: () => paymentService.getPayment(id)
  });
};
